<template>
  <div>

    <nav class="navbar customNavbar">
      <div class="navbar-brand">
        <a v-on:click="root()">
          <img class="logoClass" src="/static/logo.png">
        </a>
      </div>
      <div class="navbar-end">
        <a class="navbar-item customNavbarItem" v-on:click="root()">Inicio</a>
        <a class="navbar-item customNavbarItem" v-on:click="about()">Nosotros</a>
        <a class="navbar-item customNavbarItem" v-on:click="products()">Productos</a>
        <a class="navbar-item customNavbarItemSelected" >Noticias</a>
        <a class="navbar-item customNavbarItem" v-on:click="contact()">Contacto</a>
        <a class="navbar-item customNavbarItem" v-if="isLogged" v-on:click="logout()">Cerrar Sesión</a>
        <a class="navbar-item customNavbarItem" v-else v-on:click="login()">Iniciar Sesión</a>
      </div>
    </nav>

    <section class="section">
      <div class="columns">
          <div class="column"></div>
        <div class="column is-two-thirds">
          <h2 class="title is-2">{{newsItem.title}}</h2>
            <carousel v-if="newsItem.images.length > 0" :autoplay="true" :perPage="1" :navigationEnabled="true" :loop="true" align="center">
                <slide v-for="image of newsItem.images" :key="image.id">
                    <img class="sliderImg" :src="multimediaBase+image.imagePath" :alt="image.name" width="350px" height="150px"/>
                </slide>
            </carousel>
            <br/><br/>
            <p class="newsInfo"><i>{{newsItem.dateStr}}</i></p> <br/>
            <div class="newsDetail" v-html="newsItem.description"></div>
            <button class="button customButton" v-on:click="news">Regresar</button>
        </div>
        <div class="column"></div>
      </div>
    </section>
    <FooterComponent/>
  </div>
</template>

<script>
import ApiClient from '@/api/ApiClient.js'
import FooterComponent from './FooterComponent'

export default {
  name: 'landing',
  components: {
    FooterComponent
  },
  data () {
    return {
      isLogged: localStorage.getItem('email') !== null,
      newsItem: {
        dateStr: '',
        title: '',
        message: '',
        images: []
      },
      multimediaBase: '/multimedia/'
    }
  },
  methods: {
    root: function () {
      this.$router.push('/')
    },
    logout: function () {
      localStorage.removeItem('email')
      localStorage.removeItem('token')
      this.isLogged = false
      this.$router.push('/')
    },
    about: function () {
      this.$router.push('/about')
    },
    products: function () {
      this.$router.push('/products')
    },
    news: function () {
      this.$router.push('/news')
    },
    contact: function () {
      this.$router.push('/contact')
    },
    login: function () {
      this.$router.push('/login')
    },
    getDetail (detailId) {
      ApiClient.newsDetail(detailId).then(response => {
        if (response.data.success) {
          this.newsItem = response.data.news
        }
      }).catch(error => {
        ApiClient.onError(error)
      })
    }
  },
  created () {
    this.getDetail(this.$route.params.id)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .logoClass {
    height: 80px;
    width: 300px;
    margin-left: 20px;
    margin-top: 20px;
  }
  .newsInfo {
    font-size: medium;
    text-align: justify;
  }
  .newsDetail {
    text-align: justify;
  }
  .newsLink {
    font-size: smaller;
    float: right;
  }
  .newsContent {
    margin-bottom: 20px;
  }
  .footerInfo {
    margin-left: 100px;
    margin-right:100px;
    text-align: center;
    font-size: small;
  }
  .footerContact {
    text-align: left;
    font-size: small;
    margin-left: 100px;
    margin-right:100px;
    margin-top: 60px;
  }
  .footerLast {
    font-size: small;
    margin-bottom: 0px;
  }
</style>



// WEBPACK FOOTER //
// NewsDetailComponent.vue?422d9850